module.exports = __webpack_public_path__ + "static/img/renz.6c7a8709.webp";